const art = (props) => {
    return (
        <svg
            width="190px"
            height="122px"
            viewBox="0 0 263 170"
        >
            <g
                id="1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="full"
                    transform="translate(0.782678, 0.785104)"
                >
                    <path
                        d="M260.487552,0.396970878 C260.138317,84.4816732 259.40522,161.77516 256.960853,164.735029 C201.662141,170.616281 1.28317047,167.049645 1.29403185,165.733323 C1.35492983,158.357306 -0.120546645,15.5930987 0.00793324932,0 L260.487552,0.396970878 Z"
                        id="2"
                        fill="#EDF4FF"
                    ></path>
                    <path
                        d="M0.00925103352,0 L260.487552,0.404360889 L260.419135,15.9564747 L0.055109971,15.9564747 C0.033665812,10.6378092 -0.0218476387,5.31885679 0.00925103352,0 Z"
                        id="1"
                        fill="#171F66"
                    ></path>
                </g>
                <g
                    id="e4"
                    transform="translate(183.146723, 82.435938)"
                >
                    <path
                        d="M0,0.383337248 C0.223263314,39.0604747 0.537392846,74.6144098 1.1882291,75.979637 C15.8169469,78.7696156 68.7862843,77.4363465 68.7813601,76.8309183 C68.7538587,73.4380344 68.9215616,7.77285113 68.8633069,0.60022241 L0,0.383337248 Z"
                        id="Fill-9-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M0,0.383337248 C0.223263314,39.0604747 0.537392846,74.6144098 1.1882291,75.979637 C15.8169469,78.7696156 68.7862843,77.4363465 68.7813601,76.8309183 C68.7538587,73.4380344 68.9215616,7.77285113 68.8633069,0.60022241 L0,0.383337248 Z"
                        id="Stroke-10-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M64.179621,3.53849767 C63.4056087,4.54410893 59.8572603,7.51774035 59.8181034,7.48213114 C59.5987493,7.28244024 56.0909833,4.17649614 55.5701597,3.6516093 L64.179621,3.53849767 Z"
                        id="Fill-14-Copy"
                        fill="#CAE4FE"
                    ></path>
                    <path
                        d="M47.016869,55.0377356 C73.1867367,33.4222186 32.5985199,0.641220461 14.8337883,28.3849769 C12.1826669,32.5252983 11.4241079,36.5326873 11.8521314,40.940087 C13.2087405,54.9084439 29.2320854,66.0204346 46.8248498,55.1814968 L47.016869,55.0377356 Z"
                        id="Fill-15-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M47.016869,55.0377356 C73.1867367,33.4222186 32.5985199,0.641220461 14.8337883,28.3849769 C12.1826669,32.5252983 11.4241079,36.5326873 11.8521314,40.940087 C13.2087405,54.9084439 29.2320854,66.0204346 46.8248498,55.1814968 L47.016869,55.0377356 Z"
                        id="Stroke-16-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M47.5011618,23.2582503 C54.128853,28.4234299 58.9010945,37.6541539 54.8727775,46.1331634 C53.0719192,45.7930777 51.3279973,45.2850013 49.5471184,44.8867112 C47.4437564,44.4615574 31.4273833,41.8305105 31.3071322,40.6709918 C31.7432065,39.4556939 33.4803748,37.7762526 34.3830082,36.8069245 C35.4761486,35.632948 36.848249,34.216173 37.9247868,33.1129933 C41.1200697,29.8384326 44.448079,26.6481006 47.5011618,23.2582503 Z"
                        id="Fill-17-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M47.5011618,23.2582503 C54.128853,28.4234299 58.9010945,37.6541539 54.8727775,46.1331634 C53.0719192,45.7930777 51.3279973,45.2850013 49.5471184,44.8867112 C47.4437564,44.4615574 31.4273833,41.8305105 31.3071322,40.6709918 C31.7432065,39.4556939 33.4803748,37.7762526 34.3830082,36.8069245 C35.4761486,35.632948 36.848249,34.216173 37.9247868,33.1129933 C41.1200697,29.8384326 44.448079,26.6481006 47.5011618,23.2582503 Z"
                        id="Stroke-18-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M46.6250854,22.4439983 C48.386326,23.8881678 47.7917717,23.318062 48.5260549,24.0378356 C42.3620319,28.8137083 36.8415092,34.2797722 31.4552467,39.8228426 L31.3071322,39.0886476 C31.3959097,36.5381937 31.7386238,31.8826839 32.0889943,29.3573749 C32.5843803,24.7672235 32.0703091,22.2878594 33.3855656,17.7367196 C38.5536214,17.7749917 42.6618156,19.73833 46.6250854,22.4439983 Z"
                        id="Fill-19-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M46.6250854,22.4439983 C48.386326,23.8881678 47.7917717,23.318062 48.5260549,24.0378356 C42.3620319,28.8137083 36.8415092,34.2797722 31.4552467,39.8228426 L31.3071322,39.0886476 C31.3959097,36.5381937 31.7386238,31.8826839 32.0889943,29.3573749 C32.5843803,24.7672235 32.0703091,22.2878594 33.3855656,17.7367196 C38.5536214,17.7749917 42.6618156,19.73833 46.6250854,22.4439983 Z"
                        id="Stroke-20-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                </g>
                <g
                    id="e1"
                    transform="translate(10.174818, 23.553125)"
                >
                    <path
                        d="M163.579766,52.2046271 C163.567117,25.9389319 163.297862,1.7955933 161.777389,0.876844041 C127.23107,-0.8271594 1.98898156,0.769449259 1.99260883,1.18059914 C2.01251226,3.48453528 0.741482593,48.085083 0.782678305,52.9558293 L163.579766,52.2046271 Z"
                        id="Fill-5-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M163.579766,52.2046271 C163.567117,25.9389319 163.297862,1.7955933 161.777389,0.876844041 C127.23107,-0.8271594 1.98898156,0.769449259 1.99260883,1.18059914 C2.01251226,3.48453528 0.741482593,48.085083 0.782678305,52.9558293 L163.579766,52.2046271 Z"
                        id="Stroke-6-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0882095,11.9249808 C20.9496344,11.9472289 27.7589381,12.0402596 34.4378454,11.1499536"
                        id="Stroke-22-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0882095,17.4639615 C46.9105625,17.3718034 79.898234,19.0378547 112.705676,19.0378547"
                        id="Stroke-23-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0882095,24.6026411 C51.9241886,22.4650608 90.7587323,27.8545582 128.359242,23.7705953"
                        id="Stroke-24-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0882095,31.6584964 C30.5151801,31.6784528 46.938029,32.0591229 63.3969427,32.0591229"
                        id="Stroke-25-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M14.0882095,39.5463974 C37.5893286,40.3431073 60.9922256,40.335186 84.5292569,40.3351876"
                        id="Stroke-26-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M158.101018,5.62842286 C157.327005,6.63403412 153.778657,9.60766554 153.7395,9.57205633 C153.520146,9.37236543 150.01238,6.26642133 149.491556,5.74153449 L158.101018,5.62842286 Z"
                        id="Fill-30-Copy"
                        fill="#CAE4FE"
                    ></path>
                </g>
                <g
                    id="e3"
                    transform="translate(10.957496, 82.435938)"
                >
                    <path
                        d="M162.797087,0.897975129 C162.687621,39.4938476 162.329366,74.9718957 160.805482,76.32739 C126.252606,78.956449 1.01536988,77.0635378 1.02048514,76.4593773 C1.04894462,73.073735 -0.0577198628,7.54074091 0.00236125801,0.383337248 L162.797087,0.897975129 Z"
                        id="Fill-11-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M162.797087,0.897975129 C162.687621,39.4938476 162.329366,74.9718957 160.805482,76.32739 C126.252606,78.956449 1.01536988,77.0635378 1.02048514,76.4593773 C1.04894462,73.073735 -0.0577198628,7.54074091 0.00236125801,0.383337248 L162.797087,0.897975129 Z"
                        id="Stroke-12-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M10.174818,13.003979 C11.1172018,19.1728577 10.9444562,63.6433032 11.972469,64.6665288 C106.632739,64.6665288 138.298402,65.5611225 145.578165,64.6665288"
                        id="Stroke-21-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M21.1323142,64.113816 C21.2816136,59.0152047 21.1779004,38.5642273 21.4401583,38.4654151 C22.0990526,38.2170546 36.9466021,38.0643709 37.7009711,38.6535382 C38.9447966,39.6247476 39.1339152,61.1812808 39.1339152,64.2753359"
                        id="Stroke-31-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M54.954458,65.064126 C54.954458,59.6877897 54.6249884,31.5607212 54.8916531,31.4322252 C55.5613855,31.1094666 70.6531591,30.9111233 71.4199366,31.6766904 C72.6842215,32.9389697 72.7890824,60.6521745 72.7890824,64.6733233"
                        id="Stroke-32-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M85.4657082,64.2753359 C86.545867,59.5069984 85.0803389,22.1865755 85.3444105,22.0297638 C86.0078615,21.6358499 100.958092,21.3939415 101.717678,22.3280264 C102.970105,23.8682487 103.313536,58.8822019 103.313536,63.788692"
                        id="Stroke-33-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M119.130818,63.6000303 C119.130818,58.3307366 118.807782,30.7636771 119.06924,30.6377394 C119.725894,30.3214069 134.522873,30.1270126 135.274769,30.8773373 C136.514366,32.1144847 136.129569,61.1230381 136.129569,65.064126"
                        id="Stroke-34-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                </g>
                <g
                    id="e2"
                    transform="translate(183.146723, 23.553125)"
                >
                    <path
                        d="M68.8756908,0.130224384 C68.7502422,26.6055728 68.5260143,50.9426318 67.8785134,51.8755461 C53.2549163,53.7489013 0.274786471,52.7041238 0.278224693,52.2896939 C0.29718138,49.9671926 -0.0367908379,5.0166407 0.00335273421,0.106892117 L68.8756908,0.130224384 Z"
                        id="Fill-7-Copy"
                        fill="#FFFFFF"
                    ></path>
                    <path
                        d="M68.8756908,0.130224384 C68.7502422,26.6055728 68.5260143,50.9426318 67.8785134,51.8755461 C53.2549163,53.7489013 0.274786471,52.7041238 0.278224693,52.2896939 C0.29718138,49.9671926 -0.0367908379,5.0166407 0.00335273421,0.106892117 L68.8756908,0.130224384 Z"
                        id="Stroke-8-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M10.174818,41.1239777 C19.9114652,22.2504876 27.0437231,39.0003747 34.5239299,34.6599044 C38.2268422,32.511291 40.5598851,22.2380778 45.9823735,23.0246681 C50.6876858,23.707207 50.7956508,32.0611017 57.9181946,29.6502596"
                        id="Stroke-28-Copy"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <path
                        d="M64.179621,3.26205254 C63.4056087,4.26768566 59.8572603,7.24138172 59.8181034,7.20568445 C59.5987493,7.00607649 56.0909833,3.90006488 55.5701597,3.37507935 L64.179621,3.26205254 Z"
                        id="Fill-29-Copy"
                        fill="#CAE4FE"
                    ></path>
                    <path
                        d="M9.56658032,10.3611635 C9.56658032,13.202193 9.17408884,37.8310219 9.56658032,44.1935731 C9.59019999,44.5764639 51.761982,43.5502185 58.7008729,43.5502185"
                        id="Stroke-50-Copy-2"
                        stroke="#CAE4FE"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
export default art;
